/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1fed0296"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "data-monitor-main"
};
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';
import { useTaskStore } from '@/store/modules/downTask';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const {
      setTask
    } = useTaskStore();
    const router = useRouter();
    let loading;
    // import { ElMessage } from 'element-plus';
    const appStore = useAppStore();
    const url = process.env.VUE_APP_DATAMONITOR_URL + 'data-monitor';
    const handleDataChange = e => {
      // console.log('来自子应用的数据:', e.detail.data);
      const {
        type,
        data
      } = e.detail.data;
      if (type === 'setTask') {
        setTask(data);
      } else if (type === 'commentKey') {
        appStore.commentKey = data;
      } else if (type === 'logout') {
        const {
          logout
        } = useUserStore();
        logout().then(() => {
          router.push('/login');
        });
      }
    };
    const getUserInfo = () => {
      let user = localStorage.getItem('user') || '';
      if (user) {
        user = JSON.parse(user);
        return {
          token: user.token,
          uid: user.uid
        };
      }
      return {
        token: '',
        uid: ''
      };
    };
    const baseData = computed(() => {
      return {
        gameInfo: appStore.gameInfo,
        userInfo: getUserInfo()
      };
    });
    const handleCreate = () => {
      loading = ElLoading.service({
        lock: false,
        text: 'Loading',
        background: 'transparent'
      });
    };
    const handleMounted = () => {
      loading.close();
    };
    return (_ctx, _cache) => {
      const _component_micro_app = _resolveComponent("micro-app");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_micro_app, {
        style: {
          "width": "100%",
          "height": "100%"
        },
        name: "dataMonitor",
        url: url,
        data: _unref(baseData),
        onCreated: handleCreate,
        onMounted: handleMounted,
        baseroute: "/micro/data-monitor",
        onDatachange: handleDataChange
      }, null, 8, ["data"])]);
    };
  }
});